import type { Route } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { SuperUserGuardFn } from '../../../../libs/angular/src/lib/angular';
import { orderExistsGuard } from './guards/order-exists.guard';
import { userLevelGuard } from './guards/user-level.guard';

export const appRoutes: Route[] = [
  {
    path: 'dashboard',
    canActivate: [MsalGuard],
    loadComponent: () => import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
  },
  {
    path: 'forbidden',
    loadChildren: async () => import('@schaeffler/empty-states').then((m) => m.ForbiddenModule),
    data: {
      headingText: 'Forbidden',
      messageText: 'Sorry, you dont have access to this page',
      label: 'Forbidden',
    },
  },
  {
    path: 'order-not-found',
    loadChildren: async () => import('@schaeffler/empty-states').then((m) => m.PageNotFoundModule),
    data: {
      headingText: '- Order Not Found',
      messageText: 'Sorry, the order you are looking for does not exist',
      label: 'Order Not Found',
    },
  },
  {
    path: 'orders',
    canActivate: [MsalGuard, SuperUserGuardFn],
    loadComponent: () => import('./pages/order-list/order-list.component').then((m) => m.OrderListComponent),
  },
  {
    path: 'orders/:orderNumber',
    canActivate: [MsalGuard, SuperUserGuardFn, orderExistsGuard],
    loadComponent: () => import('./pages/order-detail/order-detail.component').then((m) => m.OrderDetailComponent),
  },
  {
    path: 'orders/:orderNumber/add-component',
    canActivate: [MsalGuard, SuperUserGuardFn, orderExistsGuard],
    loadComponent: () => import('./pages/add-component/add-component.component').then((m) => m.AddComponentComponent),
  },
  {
    path: 'orders/:orderNumber/ring/:componentId',
    canActivate: [MsalGuard, SuperUserGuardFn, orderExistsGuard],
    loadComponent: () => import('./pages/ring-detail/ring-detail.component').then((m) => m.RingDetailComponent),
  },
  {
    path: 'material-data',
    canActivate: [MsalGuard, SuperUserGuardFn],
    loadComponent: () => import('./pages/material-data/material-data.component').then((m) => m.MaterialDataComponent),
  },
  {
    path: 'approval',
    canActivate: [MsalGuard, SuperUserGuardFn],
    loadComponent: () => import('./pages/approval/approval.component').then((m) => m.ApprovalComponent),
  },
  {
    path: 'analysis',
    canActivate: [MsalGuard],
    loadComponent: () => import('./pages/analysis/analysis.component').then((m) => m.AnalysisComponent),
  },
  {
    path: 'analysis/filter',
    canActivate: [MsalGuard],
    loadComponent: () => import('./pages/analysis/analysis-filter-placeholder.component').then((m) => m.AnalysisFilterPlaceholderComponent),
  },
  {
    path: 'administration',
    canActivate: [MsalGuard, SuperUserGuardFn],
    loadComponent: () => import('./pages/administration/administration.component').then((m) => m.AdministrationComponent),
    children: [
      {
        path: 'users',
        loadComponent: () => import('./pages/administration/users/users.component').then((m) => m.UsersComponent),
      },
      {
        path: 'users/:azureId',
        loadComponent: () => import('./pages/administration/users/user-detail.component').then((m) => m.UserDetailComponent),
      },
      {
        path: 'plants',
        loadComponent: () => import('./pages/administration/plants/plants.component').then((m) => m.PlantsComponent),
      },
      {
        path: 'equipment',
        loadComponent: () => import('./pages/administration/equipment/equipment.component').then((m) => m.EquipmentComponent),
      },
      {
        path: 'test-instructions',
        loadComponent: () => import('./pages/administration/test-instructions/test-instructions.component').then((m) => m.TestInstructionsComponent),
      },
      {
        path: '',
        loadComponent: () => import('./pages/administration/dashboard/admin-dashboard.component').then((m) => m.AdminDashboardComponent),
      },
    ],
  },
  {
    path: 'reports',
    canActivate: [MsalGuard, userLevelGuard(3)],
    loadComponent: () => import('./pages/reports/reports.component').then((m) => m.ReportsComponent),
    children: [
      {
        path: 'order/:orderNumber',
        loadComponent: () => import('./pages/reports/order-report/order-report.component').then((m) => m.OrderReportComponent),
      },
      {
        path: 'order',
        loadComponent: () => import('./pages/reports/order-report/order-report.component').then((m) => m.OrderReportComponent),
      },
      {
        path: 'release-protocol',
        loadComponent: () => import('./pages/reports/release-protocol/freigabeprotokoll_order_form').then((m) => m.FreigabeprotokollOrderFormComponent),
      },
      {
        path: 'release-protocol/:orderNumber',
        loadComponent: () => import('./pages/reports/release-protocol/release-protocol').then((m) => m.ReleaseProtocolComponent),
      },
      {
        path: '',
        loadComponent: () => import('./pages/reports/dashboard/reports-dashboard.component').then((m) => m.ReportsDashboardComponent),
      },
    ],
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
];
